import { DatePicker2 } from '@alifd/next';
import wrapper from './next-wrapper';
const FormMonthPicker = wrapper(DatePicker2.MonthPicker, 'CbayelFormMonthPicker');
export const CbayelMonthPicker = DatePicker2.MonthPicker;
export default FormMonthPicker;
